import { i18n } from '@/i18n';
import { ProfileManageRequests } from '@/services/http/profile-manage-request';

export default {
  namespaced: true,
  state: {
    userData: {},
    simaModalStatus: false,
    adsModalStatus: false,
  },
  getters: {
    getUserData(state) {
      if (state?.userData?.language) {
        i18n.locale = state?.userData?.language;
        localStorage.setItem('lang', state?.userData.language);
      }
      return state.userData;
    },
    getSimaModalStatus(state) {
      return state.simaModalStatus;
    },
    getAdsModalStatus(state) {
      return state.adsModalStatus;
    },
  },
  mutations: {
    setUserData(state, userData) {
      state.userData = userData;
    },
    resetUserData(state) {
      state.userData = {};
    },
    setSelectedLanguage(state, language) {
      state.userData.language = language;
    },
    setSimaModalStatus(state, status) {
      state.simaModalStatus = status;
    },
    setAdsModalStatus(state, status) {
      state.adsModalStatus = status;
    },
  },
  actions: {
    async getUserData({ commit }) {
      const res = await ProfileManageRequests.getUserData();
      commit('setUserData', res[0].data);
    },
    setSimaModalStatus({ commit }, status) {
      commit('setSimaModalStatus', status);
    },
    setAdsModalStatus({ commit }, status) {
      commit('setAdsModalStatus', status);
    },
  },
};
